export enum FilterCategory {
  period,
  costcenter
}
